// Pulling FAQs from AirTable - this is okay because the API key is read only


// async function fetchAirtableRecords() {
//     const url = `https://api.airtable.com/v0/${baseId}/${tableName}`;
//     const response = await fetch(url, {
//         headers: {
//             Authorization: `Bearer ${apiKey}`
//         }
//     });
//     const data = await response.json();
//     return data.records;
// }

async function fetchAirtableRecords() {
    const url = 'https://mermaiddevs.com/shopify_apps/thermosoft_faqs.php?cache=2';

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return sortByPriority(data.records);
    } catch (error) {
        console.error('Error fetching Airtable records:', error);
        return [];
    }
}

// Airtable "Priority" field: lower number = shown first; blanks keep API order, after all prioritised records
function sortByPriority(records) {
    const priorityOf = record => {
        const p = record.fields['Priority'];
        return typeof p === 'number' ? p : Number.MAX_SAFE_INTEGER;
    };
    return records.sort((a, b) => priorityOf(a) - priorityOf(b));
}


async function fetchAirtableRecordsMain() {
    const records = await fetchAirtableRecords();
    displayRecordsMain(records);
}

function displayRecordsMain(records) {
    const recordsContainer = document.getElementById('FAQItemsContainer');
    records.filter(record => Object.keys(record.fields).length > 0).forEach(record => {

        if (!record.fields['Category']) return;

        const faqItem = document.createElement('div');
        faqItem.className = 'FAQ__Item Collapsible';
        faqItem.setAttribute('data-faq-category', record.fields['Category'].join(','));

        const button = document.createElement('button');
        button.className = 'Collapsible__Button';
        button.setAttribute('data-action', 'toggle-collapsible');
        button.setAttribute('aria-expanded', 'false');
        button.innerHTML = `${record.fields['Display Name']} <span class="Collapsible__Plus"></span>`;
        faqItem.appendChild(button);

        const collapsibleInner = document.createElement('div');
        collapsibleInner.className = 'Collapsible__Inner';

        const collapsibleContent = document.createElement('div');
        collapsibleContent.className = 'Collapsible__Content';

        const rte = document.createElement('div');
        rte.className = 'Rte';
        rte.innerHTML = record.fields['Content'].split('\n').map(line => `<p>${marked.parse(line, {
            sanitize: true,
            smartypants: true
        })}</p>`).join('');
        collapsibleContent.appendChild(rte);

        if (record.fields['Youtube URL']) {
            const iframe = document.createElement('iframe');
            iframe.width = '560';
            iframe.height = '315';
            iframe.src = `https://www.youtube.com/embed/${record.fields['Youtube URL'].split('watch?v=').pop()}`;
            iframe.frameBorder = '0';
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
            iframe.allowFullscreen = true;
            collapsibleContent.appendChild(iframe);
        }

        collapsibleInner.appendChild(collapsibleContent);
        faqItem.appendChild(collapsibleInner);
        recordsContainer.appendChild(faqItem);
    });

    // prepare the tabs
    hideAllFaqs();
    showFaqs(document.querySelectorAll('.FAQ__CategoryItem')[0].textContent.trim());
}

async function fetchAirtableRecordsSection() {
    const records = await fetchAirtableRecords();
    // console.log('records', records)
    displayRecordsSection(records);
}

function displayRecordsSection(records) {
    const recordsContainer = document.querySelectorAll('.FAQItemsContainer');
    
    recordsContainer.forEach(container => {
        // Clear the container first
        container.innerHTML = '';
        
        const categories = container.closest('.FAQPageContent__Content')
            .querySelector('.FAQItemsCategories')
            .getAttribute('data-categories')
            .split(',')
            .map(cat => cat.trim());

        records.filter(record => Object.keys(record.fields).length > 0).forEach(record => {
            const recordCategories = record.fields['Category'];
            if (recordCategories && categories.some(category => recordCategories.includes(category))) {
                const faqItem = document.createElement('div');
                faqItem.className = 'FAQ__Item Collapsible';

                const button = document.createElement('button');
                button.className = 'Collapsible__Button';
                button.setAttribute('data-action', 'toggle-collapsible');
                button.setAttribute('aria-expanded', 'false');
                button.innerHTML = `<h3 style="margin-bottom:0;">${record.fields['Display Name']}</h3> <span class="Collapsible__Plus"></span>`;
                faqItem.appendChild(button);

                const collapsibleInner = document.createElement('div');
                collapsibleInner.className = 'Collapsible__Inner';

                const collapsibleContent = document.createElement('div');
                collapsibleContent.className = 'Collapsible__Content';

                const rte = document.createElement('div');
                rte.className = 'Rte';
                rte.innerHTML = record.fields['Content'].split('\n').map(line => `<p>${marked.parse(line, {
                    sanitize: true,
                    smartypants: true
                })}</p>`).join('');
                collapsibleContent.appendChild(rte);

                if (record.fields['Youtube URL']) {
                    const iframe = document.createElement('iframe');
                    iframe.width = '560';
                    iframe.height = '315';
                    iframe.src = `https://www.youtube.com/embed/${record.fields['Youtube URL'].split('watch?v=').pop()}`;
                    iframe.frameBorder = '0';
                    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
                    iframe.allowFullscreen = true;
                    collapsibleContent.appendChild(iframe);
                }

                if (record.fields['Link']) {
                    const linkDiv = document.createElement('div');
                    linkDiv.style.marginTop = '10px';
                    const link = document.createElement('a');
                    link.href = record.fields['Link'];
                    link.className = 'ts-link Link--arrow';
                    link.textContent = 'Read more';
                    linkDiv.appendChild(link);
                    collapsibleContent.appendChild(linkDiv);
                }

                if (record.fields['Files']) {
                    const downloadList = document.createElement('ul');
                    downloadList.className = 'Collapsible__ContentDownloads';
                    record.fields['Files'].forEach(file => {
                        const listItem = document.createElement('li');
                        const fileLink = document.createElement('a');
                        fileLink.className = 'Link Collapsible__ContentLink';
                        fileLink.href = file.url;
                        fileLink.textContent = 'Download';
                        listItem.appendChild(fileLink);
                        downloadList.appendChild(listItem);
                    });
                    collapsibleContent.appendChild(downloadList);
                }

                collapsibleInner.appendChild(collapsibleContent);
                faqItem.appendChild(collapsibleInner);
                container.appendChild(faqItem);
            }
        });
    });
}

async function fetchAirtableRecordSingle() {
    // get the id from URL param
    const id = new URLSearchParams(window.location.search).get('id');

    const records = await fetchAirtableRecords();
    const record = records.find(record => record.id === id);
    // console.log('found record', record)
    displayRecordsSingle(record);
}

function displayRecordsSingle(record) {

    const recordsContainer = document.querySelectorAll('.FAQSingleContainer');

    recordsContainer.forEach(container => {
        // Clear the container first
        container.innerHTML = '';

        const faqItem = document.createElement('div');
        faqItem.className = 'FAQ__Item Collapsible';

        const header = document.createElement('div');
        header.innerHTML = `<h3 class="ts-h5" style="margin-bottom:0;">${record.fields['Display Name']}</h3>`;
        faqItem.appendChild(header);

        const content = document.createElement('div');

        const rte = document.createElement('div');
        rte.className = 'Rte';

        rte.innerHTML = record.fields['Content'].split('\n').map(line => `<p>${marked.parse(line, {
            sanitize: true,
            smartypants: true
        })}</p>`).join('');
        content.appendChild(rte);

        if (record.fields['Youtube URL']) {
            const iframe = document.createElement('iframe');
            iframe.width = '560';
            iframe.height = '315';
            iframe.src = `https://www.youtube.com/embed/${record.fields['Youtube URL'].split('watch?v=').pop()}`;
            iframe.frameBorder = '0';
            iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
            iframe.allowFullscreen = true;
            content.appendChild(iframe);
        }

        if (record.fields['Link']) {
            const linkDiv = document.createElement('div');
            linkDiv.style.marginTop = '10px';
            const link = document.createElement('a');
            link.href = record.fields['Link'];
            link.className = 'ts-link Link--arrow';
            link.textContent = 'Read more';
            linkDiv.appendChild(link);
            content.appendChild(linkDiv);
        }

        if (record.fields['Files']) {
            const downloadList = document.createElement('ul');
            downloadList.className = 'Collapsible__ContentDownloads';
            record.fields['Files'].forEach(file => {
                const listItem = document.createElement('li');
                const fileLink = document.createElement('a');
                fileLink.className = 'Link Collapsible__ContentLink';
                fileLink.href = file.url;
                fileLink.textContent = 'Download';
                listItem.appendChild(fileLink);
                downloadList.appendChild(listItem);
            });
            content.appendChild(downloadList);
        }

        // collapsibleInner.appendChild(collapsibleContent);
        faqItem.appendChild(content);
        container.appendChild(faqItem);

    });
}